/* eslint-disable no-useless-escape */
import { h } from 'preact';
import { useState } from 'preact/hooks';
import Swatches from './swatches';
import ColorSelector from './color-selector';
import TextInput from './text-input';
import Placements from './placements';

const Monograms = ({
  configuration,
  customizerSwatchesData,
  state,
  activeTab,
  dispatch,
}) => {
  const [showError, setShowError] = useState(false);
  const { style, color, text } = activeTab;
  if (typeof configuration === 'string') {
    // eslint-disable-next-line no-param-reassign
    configuration = JSON.parse(configuration);
  }
  const currentMonogramConfig = configuration.find(
    (curr) => curr.style.label === style,
  );
  const swatchesBlocks = customizerSwatchesData?.data?.blocks;
  const monogramBlock =
    swatchesBlocks &&
    swatchesBlocks.find(
      (block) => block.type === 'swatch-image' && block.title === style,
    );
  const monogramTextDetails = monogramBlock ? monogramBlock.text_details : '';
  const label = customizerSwatchesData?.data[state.activeTab]?.label;
  const swatchesToRender = swatchesBlocks.filter(
    (block) =>
      block.type === 'swatch-image' &&
      block.image !== '' &&
      configuration.map((c) => c.style.label).includes(block.title),
  );
  const sectionDataColors = swatchesBlocks.filter(
    (block) => block.type === 'swatch-color' && block.color !== '',
  );
  const colorsToRender = sectionDataColors.filter((block) =>
    currentMonogramConfig.colors.includes(block.title),
  );
  const defaultPlacement = {
    label: state.metafieldData?.placement || 'Standard',
    horizontal: currentMonogramConfig.style.horizontal,
    vertical: currentMonogramConfig.style.vertical,
  };

  const { placements = [defaultPlacement] } = currentMonogramConfig;

  const handleSwatchClick = ({ title }) => {
    const clickedMonogram = configuration.find(
      (curr) => curr.style.label === title,
    );
    const currentState = state[state.activeTab];

    const isDefaultPlacement = (placement) =>
      placement.label === defaultPlacement.label &&
      placement.horizontal === defaultPlacement.horizontal &&
      placement.vertical === defaultPlacement.vertical &&
      placement.imageIndex === defaultPlacement.imageIndex;

    const currentStatePlacement = state[state.activeTab].placement;

    const hasMatchingPlacement = clickedMonogram.placements?.some(
      (placement) =>
        placement.name === currentStatePlacement.name &&
        placement.horizontal === currentStatePlacement.horizontal &&
        placement.vertical === currentStatePlacement.vertical &&
        placement.imageIndex === currentStatePlacement.imageIndex,
    );

    let placement;
    if (isDefaultPlacement(currentStatePlacement) || !hasMatchingPlacement) {
      placement = clickedMonogram.placements?.[0] || {
        ...defaultPlacement,
        horizontal: clickedMonogram.style.horizontal,
        vertical: clickedMonogram.style.vertical,
        imageIndex: clickedMonogram.placements?.imageIndex,
      };
    } else {
      placement = currentStatePlacement;
    }

    let activeColor = currentState.color;
    if (!clickedMonogram.colors.includes(activeColor)) {
      const firstAvailableColor = sectionDataColors.find((block) =>
        clickedMonogram.colors.includes(block.title),
      );
      activeColor = firstAvailableColor ? firstAvailableColor.title : '';
    }

    const textValue =
      text === clickedMonogram.text.initialValue
        ? clickedMonogram.text.initialValue
        : text;
    const upperCaseValues = ['Classic Script', 'Block'];

    const nextText = upperCaseValues.includes(clickedMonogram.style.label)
      ? textValue.toUpperCase()
      : textValue;

    const maxLength = clickedMonogram.text.maxLength || 3;
    setShowError(nextText.length > maxLength);

    dispatch({
      type: 'change_monogram',
      payload: {
        ...state[state.activeTab],
        color: activeColor,
        style: title,
        text: nextText,
        textMaxLength: maxLength,
        placement,
      },
    });
  };

  const handleColorClick = ({ title, hex }) => {
    dispatch({
      type: 'change_monogram',
      payload: {
        ...state[state.activeTab],
        color: title,
        colorHex: hex,
      },
    });
  };

  const handleInputChange = ({ value }) => {
    const upperCaseValues = ['Classic Script', 'Block'];
    const payloadText = upperCaseValues.includes(
      currentMonogramConfig.style.label,
    )
      ? value.replace(/[^a-zA-Z]+/g, '').toUpperCase()
      : value.replace(/[^a-zA-Z]+/g, '');

    setShowError(payloadText.length > currentMonogramConfig.text.maxLength);

    dispatch({
      type: 'change_monogram',
      payload: {
        ...state[state.activeTab],
        text: payloadText,
      },
    });
  };

  const handlePlacementChange = (placement) => {
    dispatch({
      type: 'change_monogram',
      payload: {
        ...state[state.activeTab],
        placement,
      },
    });
  };

  if (!swatchesToRender) return null;

  return (
    <div className="border border-1 border-x-0 border-t-0 border-gray-300 pb-5 mb-5">
      <Placements
        placements={placements}
        currentPlacement={state[state.activeTab].placement}
        defaultPlacement={defaultPlacement}
        onChangeHandler={handlePlacementChange}
      />
      <Swatches
        swatchesToRender={swatchesToRender}
        clickHandler={handleSwatchClick}
        currentStyle={style}
        label={label}
        monogramTextDetails={monogramTextDetails}
      />
      <TextInput
        currentText={text}
        textMaxLength={currentMonogramConfig.text.maxLength}
        textMinLength={currentMonogramConfig.text.minLength}
        changeHandler={handleInputChange}
        showError={showError}
        spacingBottom={false}
      />
      <ColorSelector
        colorsToRender={colorsToRender}
        clickHandler={handleColorClick}
        currentColor={color}
        overlayImage={customizerSwatchesData.data.monograms.image}
        showTopBorder={true}
      />
    </div>
  );
};

export default Monograms;
